import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

/**
 * Component that tracks route changes and updates PostHog's URL property.
 * This ensures URL-based feature flags are evaluated correctly after SPA navigation.
 *
 * Should be placed inside the Router but does not render any UI.
 */
const PostHogRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render since index.js handles initial page load
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Update PostHog with the new URL and reload feature flags
    posthog.setPersonPropertiesForFlags({
      $current_url: window.location.href,
    });
    posthog.reloadFeatureFlags();
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogRouteTracker;
